import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ReactMarkdown from "react-markdown";

interface BriefingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  content: string | null;
}

export function NanoCorpBriefingDialog({ open, onOpenChange, content }: BriefingDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            📊 Briefing Stratégique NanoCorp
          </DialogTitle>
        </DialogHeader>
        <div className="prose prose-sm dark:prose-invert max-w-none">
          {content ? (
            <ReactMarkdown>{content}</ReactMarkdown>
          ) : (
            <p className="text-muted-foreground">Aucun briefing disponible.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
